import { hasSai } from '../../../Components/Organization/organizationUtils';
import { useCurrentProvider } from '../../../Components/Permissions';
import { Flag } from '../../../featureFlags';
import { Permission } from '../../../graphQL';

export const useShowBeaconNavItem = () => {
  const { currentProvider, hasPermission, featureFlags } = useCurrentProvider();
  return (
    hasPermission(Permission.SaiDataView) &&
    featureFlags.includes(Flag.SaiDashboardsEnabled) &&
    hasSai(currentProvider.organizations[0])
  );
};
